import React from "react";
import styled from "styled-components";
import Tooltip from "../Tooltip";

const BarButtonContainer = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const BarButton = styled.button<{
  buttonStyle?: React.CSSProperties;
  color?: string;
  border?: string;
  borderColor?: string;
}>`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${({ buttonStyle }): string =>
    buttonStyle?.border ? String(buttonStyle.border) : "none"};
  outline: none;
  border-radius: 16px;
  background-color: ${(props): string =>
    props.color || props.theme.colors.black};
  color: #000000;
  cursor: pointer;
  transition:
    background-color 0.3s,
    width 0.3s,
    height 0.3s,
    border-radius 0.3s;
  &:focus {
    outline: none;
  }
`;
const TopBarButton = ({
  tooltipContent,
  onClick,
  color,
  children,
  buttonStyle,
}: {
  tooltipContent?: string;
  onClick?: () => void;
  color?: string;
  children?: React.ReactNode;
  buttonStyle?: React.CSSProperties;
}): React.JSX.Element => {
  return (
    <BarButtonContainer>
      <Tooltip content={tooltipContent} position="bottom">
        <BarButton onClick={onClick} color={color} style={buttonStyle}>
          {children || "X"}
        </BarButton>
      </Tooltip>
    </BarButtonContainer>
  );
};

export default TopBarButton;
